export default __webpack_public_path__ + "static/main-terms-and-policies-generator-e1ff1ad87cf57d28bb6eb0a4da385b6d.png";